<div class="dialog-header" fxLayout="row" fxLayoutAlign="space-between center">
  <h1 mat-dialog-title>Select your AODocs domain</h1>
  <button mat-icon-button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <mat-form-field appearance="fill" class="domain-select-field">
    <mat-label>Domain</mat-label>
    <mat-select [(value)]="selectedDomain">
      <mat-select-trigger>
        {{selectedDomain}}{{selectedDomain === data.defaultDomain ? ' (default)' : ''}}
      </mat-select-trigger>
      <mat-option
        *ngFor="let item of data.domains"
        [value]="item.domain"
        [disabled]="!item.accessible"
        [matTooltip]="item.restrictionReason">
        <span class="domain-option-label">
          {{item.domain}}{{item.domain === data.defaultDomain ? ' (default)' : ''}}
        </span>
        <mat-icon *ngIf="item.domain === selectedDomain" class="domain-check-icon">check</mat-icon>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-button (click)="apply()" [disabled]="isUnchanged">Apply</button>
</div>
